import { useIntl } from "react-intl";

import TabsContent from "@/components/adg4/tabs-content/src/tabs-content";
import { useLocalizedHref } from "@/libraries/web-framework";
import { DataEventProps } from "@/libraries/wpl/foundations/src";

const ProductManagementTabContent = () => {
    const intl = useIntl();

    const cardCtaText = intl.formatMessage({
        id: "HomePageTemplateV2.tab.prodManagement.card.linkText",
        defaultMessage: "Try it out"
    });

    const cardDataEventProps: DataEventProps = {
        "data-product-key": "home",
        "data-event-component": "linkButton",
        "data-event-container": "cardSection",
        "data-event": "clicked",
        "data-label": cardCtaText,
        "data-label-english": "Try it out"
    };

    return (
        <TabsContent
            className="homepage-tabs-content"
            contentList={[
                {
                    headerText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.prodManagement.header",
                        defaultMessage: "Build products like the best of them"
                    }),
                    bodyText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.prodManagement.bodytext",
                        defaultMessage:
                            "Prioritize your most impactful ideas, build roadmaps to engage stakeholders, and plan and track your work with end-to-end visibility"
                    })
                }
            ]}
            pictureProps={{
                image: {
                    src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/pm-main.webp",
                    alt: "",
                    height: 400,
                    width: 768
                }
            }}
            tabContentEyebrowText={intl.formatMessage({
                id: "HomePageTemplateV2.tab.prodManagement.resources",
                defaultMessage: "Get started with a template"
            })}
            cardsContent={[
                {
                    headerText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.prodManagement.card1.headerText",
                        defaultMessage: "Product discovery"
                    }),
                    headerType: "h5",
                    bodyText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.prodManagement.card1.bodyText",
                        defaultMessage:
                            "Prioritize ideas and create custom shareable product roadmaps"
                    }),
                    ctaProps: {
                        primaryLinkProps: {
                            text: cardCtaText,
                            type: "basic",
                            href: useLocalizedHref(
                                "/software/jira/templates/product-discovery"
                            ),
                            doesArrowAnimate: true,
                            dataEventProps: cardDataEventProps
                        }
                    },
                    pictureProps: {
                        image: {
                            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/pm-card-1.webp",
                            alt: "",
                            height: 215,
                            width: 368
                        }
                    }
                },
                {
                    headerText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.prodManagement.card2.headerText",
                        defaultMessage: "Strategic planning"
                    }),
                    headerType: "h5",
                    bodyText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.prodManagement.card2.bodyText",
                        defaultMessage:
                            "Present your business vision and help your team understand your strategic plan"
                    }),
                    ctaProps: {
                        primaryLinkProps: {
                            text: cardCtaText,
                            type: "basic",
                            href: useLocalizedHref(
                                "/software/confluence/templates/strategic-plan"
                            ),
                            doesArrowAnimate: true,
                            dataEventProps: cardDataEventProps
                        }
                    },
                    pictureProps: {
                        image: {
                            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/pm-card-2.webp",
                            alt: "",
                            height: 215,
                            width: 368
                        }
                    }
                },
                {
                    headerText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.prodManagement.card3.headerText",
                        defaultMessage: "Product requirements"
                    }),
                    headerType: "h5",
                    bodyText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.prodManagement.card3.bodyText",
                        defaultMessage:
                            "Keep track of your pre-launch prep and post-launch progress"
                    }),
                    ctaProps: {
                        primaryLinkProps: {
                            text: cardCtaText,
                            type: "basic",
                            href: useLocalizedHref(
                                "/software/confluence/templates/product-requirements"
                            ),
                            doesArrowAnimate: true,
                            dataEventProps: cardDataEventProps
                        }
                    },
                    pictureProps: {
                        image: {
                            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/pm-card-3.webp",
                            alt: "",
                            height: 215,
                            width: 368
                        }
                    }
                }
            ]}
        />
    );
};

export { ProductManagementTabContent };
